<template>
  <section>
    <div class="row">
      <div class="col-md-12 custom-header">
        <div class="input-group custom-title"></div>
        <week-selector
          class="custom-selector"
          :weeks="weeks"
          :week="week"
          :isCoach="true"
          @change="changingWeek"
        />
      </div>
    </div>
    <div class="row mt-2 mb-2">
      <component-status />
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import WeekSelector from '../elements/week-selector'
import ComponentStatus from './progress/component-status'
export default {
  name: 'client-dashboard',
  components: {
    WeekSelector,
    ComponentStatus,
  },
  async mounted() {
    await this.init()
  },
  emits: ['weekChanged', 'changed'],
  computed: {
    ...mapGetters('usercardio', ['member', 'summary']),
    ...mapGetters('dashboardComponents', ['components']),
    weeks() {
      let _data = []
      if (this.summary) {
        _data = this.summary.weeks
      }
      return _data
    },
    week() {
      let _data = ''
      if (this.summary) {
        _data = this.summary.week.name
      }
      return _data
    },
    date() {
      let _data = ''
      if (this.summary) {
        _data = moment(this.summary.week.value).format('YYYY-MM-DD')
      }
      return _data
    },
  },
  methods: {
    ...mapActions('usercardio', ['getMember']),
    ...mapActions('dashboardComponents', ['getMemberStatus']),
    async init() {
      if (this.member === undefined || this.member === null) {
        await this.getMember({
          id: this.member.id,
          date: this.date,
        })
      }
      await this.weekChanged()
    },
    async changingWeek(week) {
      await this.weekChanged(week)
      this.$emit('changed')
    },
    async weekChanged(date) {
      let data = {
        orgId: this.summary.organization.id,
        userId: this.member.id,
        dateStart: moment(this.summary.week.value).format('YYYY-MM-DD'),
      }
      await this.getMemberStatus(data)
      this.$emit('weekChanged', date)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  position: relative;
}
.custom-title {
  position: absolute;
  left: 0;
  top: 0;
  button {
    top: -10px;
  }
}
.custom-selector {
  width: 265px;
  margin: 0 auto;
}
.custom-border {
  border-bottom: 1px solid rgb(222, 226, 230);
}
</style>
